export const init = () => {
  CUBE.Analytics.enhanced.list.es6.initImpression();
};



// WEBPACK FOOTER //
// ./src/analytics/enhanced/ec-impression-list.js